module.exports = __webpack_public_path__ + "img/1540359738.a7231f17.jpg";